import { render, staticRenderFns } from "./MenuCollapse.vue?vue&type=template&id=642063ac&"
import script from "./MenuCollapse.vue?vue&type=script&lang=js&"
export * from "./MenuCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports